import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
import type { DisplayAdmin, DisplayCreated, DisplayInput } from './types';

// Hooks d'administration des ecrans TV (lot 6).

export function useDisplays() {
  return useQuery({
    queryKey: ['displays'],
    queryFn: () => api.get<DisplayAdmin[]>('/displays'),
    // Le voyant de vie (lastSeenAt) doit rester frais.
    refetchInterval: 30_000,
  });
}

function useInvalidate() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ['displays'] });
}

export function useCreateDisplay() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: (input: DisplayInput) => api.post<DisplayCreated>('/displays', input),
    onSuccess: invalidate,
  });
}

export function useUpdateDisplay() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: (input: { id: number; data: DisplayInput }) => api.put<DisplayAdmin>(`/displays/${input.id}`, input.data),
    onSuccess: invalidate,
  });
}

export function useRotateToken() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: (id: number) => api.post<DisplayCreated>(`/displays/${id}/rotate-token`, {}),
    onSuccess: invalidate,
  });
}

export function useDeleteDisplay() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: (id: number) => api.del(`/displays/${id}`),
    onSuccess: invalidate,
  });
}
